export enum DocumentTypeEnum {
  Invoice = "Invoice",
  StockInvoice = "Stock Invoice",
  Expense = "Expense",
  MultiPage = "Multi-page",
  None = "None"
}